require('../brokerTransferValuesStep.scss');
require('./brokerTransferValuesStep1.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
// @ helpers
const { FormattedText,formatText } = require('core/i18n').i18n;
// @ components
const StocksContractDropdown = require('components/broker/commons/stocksContractDropdown/stocksContractDropdown');
// @ constants
const {
    BROKER_STOCKS_CONTRACT_DROPDOWN_ACCOUNT_TRANSFER_VALUES_MODIFIER,
    BROKER_NO_STOCKS_ACCOUNT_SELECTED,
    FIRST_STEP
} = require('constants/index');

class BrokerTransferValuesStep1 extends React.Component {
    constructor(props) {
        super(props);

        this.buildStocksContractDropdownOptions = this.buildStocksContractDropdownOptions.bind(this);
        this.handleAccountFromChange = this.handleAccountFromChange.bind(this);
        this.handleAccountToChange = this.handleAccountToChange.bind(this);
    }

    buildAccountSelector({title, label, handler, options, selectedValue, valid, placeholder, errorStringCode}) {
        let errorState = !valid && selectedValue === BROKER_NO_STOCKS_ACCOUNT_SELECTED;

        if (valid === undefined) {
            valid = true;
            errorState = false;
        }

        return (
            <section className="broker-transfer-values-step-one__selector">
                <h3 className="broker-transfer-values-step-one__selector-title">
                    <FormattedText value={title} />
                </h3>
                <StocksContractDropdown
                    label={label}
                    onStockContractChange={handler}
                    options={options}
                    selectedValue={selectedValue}
                    placeholder={placeholder}
                    modifier={BROKER_STOCKS_CONTRACT_DROPDOWN_ACCOUNT_TRANSFER_VALUES_MODIFIER}
                    errorState={errorState}
                    errorMessage={formatText(errorStringCode)}
                />
            </section>
        );
    }

    buildStocksContractDropdownOptions(excludeOption, showEmptyAccounts = true) {
        const { immStocksContracts } = this.props;
        // TODO: once we integrate with the API we should update the following map statement.
        // In this map statement we should format the information comming from the backend to
        // the final structure needed by the stocks Contract dropdown.
        const processedStocksContract = immStocksContracts.filter(entry => {
            return (
                ((entry.getIn(['walletBalance', 'amount']) !== 0 && !showEmptyAccounts)
                || showEmptyAccounts) && (
                    excludeOption === BROKER_NO_STOCKS_ACCOUNT_SELECTED
                    || (excludeOption && entry.get('walletNumber') !== excludeOption.walletNumber)
                    || !excludeOption
                )
            );
        });
        const options = processedStocksContract.map((entry, index) => {
            const newEntry = entry.merge({ value: index });
            return newEntry;
        });
        return options.toJS();
    }

    handleAccountFromChange(accountId) {
        const accountIdFrom = this.props.immTransferValues.getIn(['steps', FIRST_STEP, 'accountIdFrom']);

        if (accountId !== accountIdFrom) {
            const accountsFromOptions = this.buildStocksContractDropdownOptions(accountId, false);
            const accountFromValue = accountsFromOptions[accountId];
            const accountsToOptions = this.buildStocksContractDropdownOptions(accountFromValue);
            this.props.setAccountFrom(accountId);
            this.props.setAccountsFromOptions(accountsFromOptions);
            this.props.setAccountsToOptions(accountsToOptions);
            this.props.resetContractErrors();
        }
    }

    handleAccountToChange(accountId) {
        const accountIdTo = this.props.immTransferValues.getIn(['steps', FIRST_STEP, 'accountIdTo']);

        if (accountId !== accountIdTo) {
            const accountsFromOptions = this.buildStocksContractDropdownOptions(accountId, false);
            const accountIdFrom = this.props.immTransferValues.getIn(['steps', FIRST_STEP, 'accountIdFrom']);
            const accountFromValue = accountsFromOptions[accountIdFrom];
            this.props.setAccountTo(accountId);
            const accountsToOptions = this.buildStocksContractDropdownOptions(accountFromValue);
            this.props.setAccountsToOptions(accountsToOptions);
        }
    }

    render() {
        const { immTransferValues } = this.props;
        const placeholder = formatText('broker-stocksBuyStep1SelectPlaceholder');
        const accountIdFrom = immTransferValues.getIn(['steps', 0, 'accountIdFrom']);
        const accountIdTo = immTransferValues.getIn(['steps', 0, 'accountIdTo']);
        const selectOriginOptions = this.buildStocksContractDropdownOptions(accountIdTo, false);
        const accountFromValue = selectOriginOptions[accountIdFrom];
        const selectDestinyOptions = this.buildStocksContractDropdownOptions(accountFromValue);

        const accountFromSelector = this.buildAccountSelector({
            title: 'broker-transferValuesStep1SelectAccountFrom',
            label: 'broker-transferValuesStep1AccountFrom',
            handler: this.handleAccountFromChange,
            options: selectOriginOptions,
            selectedValue: immTransferValues.getIn(['steps', 0, 'accountIdFrom']),
            valid: immTransferValues.getIn(['steps', 0, 'validContracts']),
            errorStringCode: 'broker-transferInternalValuesEmptyFromAccountError',
            placeholder,
        });
        const accountToSelector = this.buildAccountSelector({
            title: 'broker-transferValuesStep1SelectAccountTo',
            label: 'broker-transferValuesStep1AccountTo',
            handler: this.handleAccountToChange,
            options: selectDestinyOptions,
            selectedValue: immTransferValues.getIn(['steps', 0, 'accountIdTo']),
            valid: immTransferValues.getIn(['steps', 0, 'validContracts']),
            errorStringCode: 'broker-transferInternalValuesEmptyToAccountError',
            placeholder,
        });

        return (
            <article className="broker-transfer-values-step broker-transfer-values-step-one">
                <header className="broker-transfer-values-step__header">
                    <FormattedText value="broker-transferValuesStep1Title" className="broker-transfer-values-step__title" />
                </header>
                <section className="broker-transfer-values-step__content">
                    {accountFromSelector}
                    {accountToSelector}
                </section>
            </article>
        )
    }
}

BrokerTransferValuesStep1.propTypes = {
    immStocksContracts: PropTypes.object.isRequired,
    immTransferValues: PropTypes.object.isRequired,
    resetContractErrors: PropTypes.func.isRequired,
    setAccountFrom: PropTypes.func.isRequired,
    setAccountTo: PropTypes.func.isRequired,
    setAccountsFromOptions: PropTypes.func.isRequired,
    setAccountsToOptions: PropTypes.func.isRequired
}

module.exports = BrokerTransferValuesStep1
